import { render } from "./RTC.vue?vue&type=template&id=c8d3663c"
import script from "./RTC.vue?vue&type=script&lang=js"
export * from "./RTC.vue?vue&type=script&lang=js"

import "./RTC.vue?vue&type=style&index=0&id=c8d3663c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__